/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const upsertEstimationRequestSchema = z.object({
  highEffort: z.int().nullish(),
  id: z.int().nullish(),
  label: z.string(),
  lowEffort: z.int().nullish(),
});
